
import styles from './content_and_button.module.sass'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Button from './basic/button'
import classNames from 'classnames'

function ContentAndButton(props) {
	const fields = props.fields
	const inlineStyles = {maxWidth: fields.max_width ? fields.max_width : null}

	return <BlockWrapper {...props}>
		<ScrollAnimation styles={styles}>
			{fields && fields.content &&
				<div className={classNames(styles.wysiwyg)} dangerouslySetInnerHTML={{__html: fields.content}} style={inlineStyles}></div>
			}
			{fields.button && fields.button.url &&
				<div className={styles.button_wrapper}>
					<Button fields={{button: fields.button, button_style: fields.button_style, button_color: fields.button_color}}>{fields.button.title}</Button>
				</div>
			}
		</ScrollAnimation>
	</BlockWrapper>
}

export default ContentAndButton